































import { Vue, Component, Prop } from "vue-property-decorator";
import User, { getAdminFlag, getLatestLicences } from "@/data/models/User";
import { localiceLicence } from "@/data/models/Licence";
import UserFormComponent from "@/components/users/UserFormDialog.vue";
import { formatUserValidationLevel } from "@/utils/LocalisationHelper";
import { getRoleLabel } from "@/data/models/RoleSettings";

@Component({
  components: {
    "user-form": UserFormComponent,
  },
})
export default class UserItemNonClickableComponent extends Vue {
  @Prop() readonly user!: User;

  get licences() {
    const licences = getLatestLicences(this.user.licenceInfo) ?? [];

    return licences
      .map((licence) => localiceLicence(licence, this).substring(0, 1))
      .join("");
  }

  get admin() {
    if (getAdminFlag(this.user)) {
      return this.$t("common.isAdmin");
    }
    return "";
  }

  get validationLevel(): string {
    return formatUserValidationLevel(this, this.user.validationLevel);
  }

  get roleLabel(): string {
    const role = this.user.role;
    if (!role) return "";
    return getRoleLabel(role, this);
  }
}
